import React, { forwardRef } from 'react';
import Turnstile from 'react-turnstile';

export const TurnstileCaptcha = forwardRef((props, ref) => {
  return (
    <Turnstile
      {...props}
      ref={ref}
    />
  );
});
